// Get default title from HTML
export const defaultTitle = document.title;

export function setTitle(title: string) {
  document.title = `${title} | ${defaultTitle}`;
}
